import { memo, useEffect, useState } from 'react';
import Facets from './Facets';
import { useErrorContext } from '../../context/ErrorContext';
import constants from '../../utils/constants';

const useLeftNavFacetsData = () => {
  const { hasFacetsError = false } = useErrorContext();

  return {
    hasFacetsError,
  };
};

export const LeftNavFacets = memo(() => {
  const { hasFacetsError } = useLeftNavFacetsData();
  const [displayFacets, setDisplayFacets] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setDisplayFacets(window.innerWidth >= constants.MOBILE_MAX_WIDTH);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (hasFacetsError || !displayFacets) return null;

  return <Facets />;
});

LeftNavFacets.displayName = 'LeftNavFacets';
